import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { apiJson } from '@/lib/api/client'

interface SystemSetting {
  key: string
  value: unknown
  forced: boolean
  updated_by: string | null
  updated_at: string
}

export const Route = createFileRoute('/_app/admin/settings')({
  component: SystemSettingsPage,
})

function SystemSettingsPage() {
  const settings = useQuery({
    queryKey: ['admin', 'system-settings'],
    queryFn: () => apiJson<SystemSetting[]>('/api/admin/system-settings'),
  })

  return (
    <div className="p-8 space-y-8 max-w-3xl">
      <h1 className="text-2xl font-medium tracking-tight">System settings</h1>
      <p className="text-sm text-muted-foreground">
        Settings here apply globally across every organization. Toggling{' '}
        <em>forced</em> prevents per-org overrides.
      </p>

      <section className="space-y-4">
        {(settings.data ?? []).length === 0 && (
          <div className="border border-border rounded-lg p-5 text-sm text-muted-foreground">
            No system settings are defined yet.
          </div>
        )}

        <RawSettings settings={settings.data ?? []} />
      </section>
    </div>
  )
}

function RawSettings({ settings }: { settings: SystemSetting[] }) {
  const [open, setOpen] = useState(false)
  return (
    <details
      open={open}
      onToggle={(e) => setOpen((e.target as HTMLDetailsElement).open)}
      className="border border-border rounded-lg p-5"
    >
      <summary className="cursor-pointer text-sm font-medium">
        Raw JSON
      </summary>
      <pre className="mt-3 text-xs font-mono bg-secondary p-3 rounded overflow-x-auto">
        {JSON.stringify(settings, null, 2)}
      </pre>
    </details>
  )
}
